export default __webpack_public_path__ + "static/bucky-e64ba90f0ee7b26d40983fd8c9f04495.jpeg";